export function initCoffeeSetsCollapse() {
    const $items = $('[data-set-item]');

    function toggleView({ card, contentWrapper, content }) {
        card.toggleClass('coffee-set-item--active');

        if (card.hasClass('coffee-set-item--active')) {
            contentWrapper.css({
                maxHeight: `${content.height()}px`,
            });
            return;
        }

        contentWrapper.removeAttr('style');
    }

    $items.each((_, item) => {
        const card = $(item);
        const toggleBtn = $('[data-toggle]', item);
        const contentWrapper = $('[data-wrapper]', item);
        const content = $('[data-content]', item);

        if ($('tr', content).length <= 6) {
            card.addClass('coffee-set-item--short');
            return;
        }

        toggleBtn.on('click', (event) => {
            event.preventDefault();
            const swiperContainer = toggleBtn.closest('.swiper-wrapper');
            if (swiperContainer.length) {
                swiperContainer.addClass('h-auto');
            }

            toggleView({
                card,
                contentWrapper,
                content,
            });
        });
    });
}
